import { render, staticRenderFns } from "./logisticsList.vue?vue&type=template&id=7ead001e&scoped=true&"
import script from "./logisticsList.vue?vue&type=script&lang=ts&"
export * from "./logisticsList.vue?vue&type=script&lang=ts&"
import style0 from "./logisticsList.vue?vue&type=style&index=0&id=7ead001e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ead001e",
  null
  
)

export default component.exports